export default __webpack_public_path__ + "static/media/yo10.9b1c2e3b.png";